'use client'

import { Header, ListBoxSection } from 'react-aria-components'
import { SelectListItem, type SelectListItemData } from './SelectListItem.client'

export type SelectListSectionData = {
  id: string | number
  label: string
  items: SelectListItemData[]
}

type SelectListSectionProps = {
  section: SelectListSectionData
}

export function SelectListSection({ section }: SelectListSectionProps) {
  return (
    <ListBoxSection id={section.id}>
      <Header className="notranslate font-bold" translate="no">
        <div className="w-full px-2 pt-1">{section.label}</div>
      </Header>
      {section.items.map((item) => (
        <SelectListItem key={item.id} item={item} />
      ))}
    </ListBoxSection>
  )
}
